import React, { useState } from 'react'

import { PlayIcon } from '@application/Interfaces/Icons'
import { VideoType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Link } from '@src/Application/Interfaces/Atoms/Link'

import { appendAutoPlayToURL, onPlay } from './utils'
import { Button, Cover, ImageWrapper, TitleSection, VideoIframe, VideoWrapper } from './Video.styled'

export const Video = ({
    title,
    subtitle,
    mode,
    cover,
    buttonLink,
    buttonLabel,
    youtubeVideoUrl,
}: VideoType): JSX.Element => {
    const [playing, setPlaying] = useState(false)

    return (
        <TitleSection title={title} subtitle={subtitle} mode={mode}>
            <Grid container columnSpacing={6} rowSpacing={{ xs: 5, md: 10 }}>
                <ImageWrapper onClick={onPlay(setPlaying)} data-testid="play-button">
                    <Cover image={cover} />
                    <Grid container component={VideoWrapper} justifyContent="center" alignContent="center">
                        {playing ? (
                            <VideoIframe
                                src={appendAutoPlayToURL(youtubeVideoUrl)}
                                frameBorder="0"
                                allow="autoplay"
                                allowFullScreen
                            />
                        ) : (
                            <PlayIcon />
                        )}
                    </Grid>
                </ImageWrapper>
                {buttonLabel && buttonLink && (
                    <Grid item xs={12} textAlign="center">
                        <Link to={buttonLink}>
                            <Button>{buttonLabel}</Button>
                        </Link>
                    </Grid>
                )}
            </Grid>
        </TitleSection>
    )
}
